import React from 'react';
import './../helper/dropdown.css'

var uniqueID = 0;
const getUniqueID = () => {
    uniqueID = uniqueID + 1;
    return uniqueID;
}

class StaticTable extends React.Component{

    constructor(props){
        super(props)
        this.verticalTable.bind(this)
        this.horrizontalTable.bind(this)
        //data is a list of rows, where the first row contains the headers

        this.state = {headers:props.data[0],
                        data:props.data.splice(1),
                        vertical:props.vertical}
        this.headerWidth = 0
        this.state.headers.forEach(e => {
            if (e.length > this.headerWidth)
                this.headerWidth = e.length
            }
        );
    }
    

    horrizontalTable(){
        return (
            <div>
                <div className="tablesaw-bar tablesaw-mode-stack" style={{margin: "5px"}}/>
                <table id="tablesaw2" className="table table-sortable tablesaw-stack ">
                    <thead>
                        <tr>
                            {this.state.headers.map(h => 
                                <th data-tablesaw-sortable-col key={getUniqueID()}
                                    dangerouslySetInnerHTML={{__html:h}}>{}
                                </th>)
                            }
                        </tr>
                    </thead>
                    <tbody>
                        {this.state.data.map(o => <tr>
                            {o.map(key => 
                                <td key={getUniqueID()}>{key}</td>
                            )}
                        </tr>)}
                    </tbody>
                </table>
            </div>
        )
    }

    verticalTable(){
        return (
            <div>
                <div className="tablesaw-bar tablesaw-mode-stack" style={{margin: "5px"}}/>
                <table id="tablesaw2" className="table tablesaw-stack ">
                        <tr>
                            {this.state.headers.map((h,i) =>
                                <div>
                                <th data-tablesaw-sortable-col key={getUniqueID()}
                                    dangerouslySetInnerHTML={{__html:h}} style={{minWidth:this.headerWidth*8 + 10}}>{}
                                </th>
                                {this.state.data.map(o =>
                                    <td>{o[i]}</td>)}
                                </div>
                                )
                            }
                        </tr>
                </table>
            </div>
        )
    }

    render(){
        return (
            <div>
                <h2>{this.props.tableName}</h2>
                <hr></hr>
                {
                this.state.vertical ?
                this.verticalTable() :
                this.horrizontalTable()
                }
            </div>
        )
    }
}

export default StaticTable;